module.exports = __webpack_public_path__ + "files/ght.2ca18e4df6642c59646a87be3f94f84b.pdf";